export default __webpack_public_path__ + "static/spanish-5cd74d3654ac6c1824e0211b66edeb73.png";